import React, { useState, useEffect } from 'react';
import { Button, Grid, Header, Input, Table } from 'semantic-ui-react';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { getGroupApplications, getAppListV2, setGroupApplications } from '../../../api/apiCalls';
import {
    APPLICATION_HEADER,
    SEARCH_APPLICATION_PLACEHOLDER,
    SUCCESS_MESSAGE,
    TOTAL_NUMBER_OF_APPLICATIONS_LABEL
} from '../../../utils/UIMessages';
import {
    ANGLE_DOUBLE_LEFT_ICON,
    ANGLE_DOUBLE_RIGHT_ICON,
    CHEVRON_LEFT_ICON,
    CHEVRON_RIGHT_ICON
} from '../../../utils/UiIcons';
import { showSuccess } from '../../../utils/ToastHelpers';

//TODO: manage group application versions
const ManageGroupApplications = ({ selectedGroup }) => {
    const [allApps, setAllApps] = useState([]);
    const [selectedApps, setSelectedApps] = useState([]);
    const [searchKeywordAll, setSearchKeywordAll] = useState('');
    const [searchKeywordSelected, setSearchKeywordSelected] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        getAppListV2({"groupIds":"0"}).then(res => {
            setAllApps(res.data);
        });
    }, []);

    useEffect(() => {
        getGroupApplications(selectedGroup.id).then(res => {
            setSelectedApps(res.data.applications);
        });
    }, [selectedGroup]);

    const filteredUnselectedApps = allApps.filter(
        app => !selectedApps.some(sApp => sApp.id === app.id) &&
            app.name.toLowerCase().includes(searchKeywordAll.toLowerCase())
    );

    const filteredSelectedApps = selectedApps.filter(
        app => app.name.toLowerCase().includes(searchKeywordSelected.toLowerCase())
    );

    const onClickAddApp = appId => {
        const appToAdd = allApps.find(app => app.id === appId);
        if (appToAdd) setSelectedApps(prev => [...prev, appToAdd]);
    };

    const onClickAddAllApps = () => {
        setSelectedApps(allApps);
    };

    const onClickRemoveAllApps = () => {
        setSelectedApps([]);
    };

    const onClickDeleteApp = appId => {
        setSelectedApps(selectedApps.filter(app => app.id !== appId));
    };

    const onClickSave = () => {
        setSaving(true);

        setGroupApplications(selectedGroup.id, {appIds: selectedApps.map(app => app.id), appVerIds: []})
        .then(() => {
            showSuccess(SUCCESS_MESSAGE());
        })
        .finally(() => setSaving(false));
    };

    return (
        <div>
            <Grid columns={2} celled={'internally'} centered>
                <Grid.Column>
                    <div className='manage-group-container'>
                        <Input fluid 
                            onChange={(e, { value }) => setSearchKeywordAll(value)}
                            placeholder={SEARCH_APPLICATION_PLACEHOLDER()}
                            value={searchKeywordAll}
                        />
                        <Table basic='very' celled compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>{APPLICATION_HEADER()}</Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {filteredUnselectedApps.length > 1 && (
                                            <Button icon={ANGLE_DOUBLE_RIGHT_ICON} primary onClick={onClickAddAllApps} />
                                        )}
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.orderBy(filteredUnselectedApps, ['name'], ['asc']).map(app => (
                                    <Table.Row key={app.id}>
                                        <Table.Cell>
                                            <Header as='h4' image={`data:image/png;base64,${app.icon}`} content={app.name} />
                                        </Table.Cell>
                                        <Table.Cell width={'3'}>
                                            <Button icon={CHEVRON_RIGHT_ICON} primary onClick={() => onClickAddApp(app.id)} />
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </div>
                    <div className='count-total-number'>
                        {TOTAL_NUMBER_OF_APPLICATIONS_LABEL()}: {filteredUnselectedApps.length}
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className='manage-group-container'>
                        <Input fluid 
                            onChange={(e, { value }) => setSearchKeywordSelected(value)}
                            placeholder={SEARCH_APPLICATION_PLACEHOLDER()}
                            value={searchKeywordSelected}
                        />
                        <Table basic='very' celled compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        {filteredSelectedApps.length > 1 && (
                                            <Button icon={ANGLE_DOUBLE_LEFT_ICON} color='red' onClick={onClickRemoveAllApps} />
                                        )}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>{APPLICATION_HEADER()}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {filteredSelectedApps.map(app => (
                                    <Table.Row key={app.id}>
                                        <Table.Cell width={'3'}>
                                            <Button icon={CHEVRON_LEFT_ICON} color='red' onClick={() => onClickDeleteApp(app.id)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Header as='h4' image={`data:image/png;base64,${app.icon}`} content={app.name} />
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </div>
                    <div className='count-total-number'>
                        {TOTAL_NUMBER_OF_APPLICATIONS_LABEL()}: {filteredSelectedApps.length}
                    </div>
                    <Button onClick={onClickSave} fluid color='green' disabled={saving}>Save</Button>
                </Grid.Column>
            </Grid>
        </div>
    );
};

export default withTranslation()(ManageGroupApplications);
